import { clacUiGlobal as ui } from 'utils/uiGlobal';

/**
 * Única fuente de verdad para los 3 niveles de debida diligencia (nivel_dd).
 * Coincide con el ENUM `evaluaciones.tipo` y el catálogo `nivel_dd` (columna `codigo`).
 * Fusión Intensificada+Reforzada → Ampliada aplicada en la migración
 * `2026_08_20_000000_rename_intensificada_to_ampliada_softdelete_reforzada.php` — no reintroducir esos nombres.
 */
export const NIVEL_DD = {
  SIMPLIFICADA: 'simplificada',
  ESTANDAR: 'estandar',
  AMPLIADA: 'ampliada'
} as const;

export type NivelDd = (typeof NIVEL_DD)[keyof typeof NIVEL_DD];

export const NIVELES_DD: readonly NivelDd[] = [NIVEL_DD.SIMPLIFICADA, NIVEL_DD.ESTANDAR, NIVEL_DD.AMPLIADA];

export const NIVEL_DD_LABEL: Record<NivelDd, string> = {
  simplificada: 'Simplificada',
  estandar: 'Estándar',
  ampliada: 'Ampliada'
};

export const NIVEL_DD_BADGE_SX: Record<NivelDd, { bgcolor: string; color: string; borderColor: string }> = {
  simplificada: { bgcolor: ui.semantic.success.bg, color: ui.semantic.success.text, borderColor: ui.semantic.success.border },
  estandar: { bgcolor: ui.semantic.accent.bg, color: ui.semantic.accent.text, borderColor: ui.semantic.accent.border },
  ampliada: { bgcolor: ui.semantic.danger.bg, color: ui.semantic.danger.text, borderColor: ui.semantic.danger.border }
};

export function isNivelDd(value: unknown): value is NivelDd {
  return value === NIVEL_DD.SIMPLIFICADA || value === NIVEL_DD.ESTANDAR || value === NIVEL_DD.AMPLIADA;
}

/** Normaliza texto libre ("Estándar", "AMPLIADA", el nombre de catálogo, etc.) al código canónico. */
export function normalizeNivelDd(value: string | null | undefined): NivelDd | null {
  if (!value) return null;
  const v = value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
  return isNivelDd(v) ? v : null;
}
